import * as theme from "../theme";
import { useDispatch, useSelector } from "react-redux";
import {
  answerChanged,
  manipulateQuestion,
  currentNodeChanged,
  getCurrentNode,
  getNode,
  updateTrackingQAnsweredFinalValues,
  AddtoClientLog,
  getFormState,
  getExpressApplication,
  getExpressImportanctFactor,
  getflashQId,
  handleflashQid,
  getProspectDoc,
} from "../store/qf";
import {
  changeHelpOrTipText,
  getLanguageCode,
  getQFuserMode,
} from "../store/components";
import { getLanguagePreference, getBrokerInformation } from "../store/broker";
import { useEffect, useRef, useContext, createContext } from "react";
import _ from "lodash";

import { BROKER, CLIENT, MESSAGE } from "../store/businesslogic/hardwiredlogic";
import Question from "../questions/Question";
import { isInViewport } from "./resusableFuncs";

const EachQuestion = ({
  formid,
  questionid,
  locationid,
  isBuilding = false,
  buildingIndex,
  groupid,
}) => {
  const currentnode = useSelector(getCurrentNode);
  const node = useSelector(
    getNode({ formid, questionid, locationid, isBuilding, buildingIndex })
  );
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;
  const qfusermode = useSelector(getQFuserMode);
  const formState = useSelector(getFormState);
  const isExpressApplication = useSelector(getExpressApplication);
  const importanceFactor = useSelector(getExpressImportanctFactor);
  const qflashid = useSelector(getflashQId);
  const gotProspectDetails = useSelector(getProspectDoc);

  const isClient = qfusermode === CLIENT;
  let text = "";
  if (node?.clienttext?.[languagecode] || node?.text?.[languagecode])
    text = isClient
      ? node.clienttext[languagecode]
        ? node.clienttext[languagecode]
        : node.text[languagecode]
      : node.text[languagecode];

  const hint = node?.hint?.[languagecode];
  const type = node.type;
  const queRef = useRef(null);
  const isNodeOpen = currentnode.id === node.id;
  const QuestionComponent = Question({ type });
  const dispatch = useDispatch();

  const findDifferences = (obj1, obj2) => {
    let differences = [];
    function compareValues(key, value1, value2) {
      if (value1 !== value2) {
        differences.push({
          question: key,
          old_answer: value1,
          new_answer: value2,
        });
      }
    }
    function deepCompare(obj1, obj2, parentKey = "") {
      for (let key in obj1) {
        const newKey = parentKey ? `${parentKey} -> ${key}` : key;
        if (
          typeof obj1[key] === "object" &&
          obj1[key] !== null &&
          !Array.isArray(obj1[key])
        ) {
          deepCompare(obj1[key], obj2[key], newKey);
        } else {
          compareValues(newKey, obj1[key], obj2[key]);
        }
      }
    }
    deepCompare(obj1, obj2);
    return differences;
  };

  const handleAnswerChange = (changedValue) => {
    if (changedValue && typeof changedValue === "object") {
      delete changedValue.detail;
    }
    dispatch(currentNodeChanged(node));
    var storeAnswer =
      typeof changedValue === "string" || changedValue instanceof String
        ? changedValue
        : JSON.stringify(changedValue);

    // Address questions (ending in "110") use separate storage based on "Same as Main?" answer
    if (
      node.id &&
      node.id.slice(-3) === "110" &&
      node.locationid &&
      storeAnswer !== undefined &&
      storeAnswer.trim() !== ""
    ) {
      // Check if "Same as Main?" is set to "No"
      const sameAsMainValue = sessionStorage.getItem(`location_${node.locationid}_500100`);
      let isNo = false;

      try {
        // Parse the JSON value and check if it's "No"
        isNo = JSON.parse(sameAsMainValue) === "No";
      } catch (e) {
        // If parsing fails, try direct comparison
        isNo = sameAsMainValue === "No";
      }

      if (isNo) {
        // When "Same as Main?" is "No", save to the _no key
        sessionStorage.setItem(node.id + "_no", storeAnswer);
      } else {
        // When "Same as Main?" is "Yes", save to the regular key
        sessionStorage.setItem(node.id, storeAnswer);
      }
    } else {
      // For all other cases, use the regular key
      if (storeAnswer !== undefined && storeAnswer.trim() !== "") {
        sessionStorage.setItem(node.id, storeAnswer);
      } else {
        sessionStorage.removeItem(node.id);
      }
    }

    if (isClient) {
      var newAnswer = "";
      var oldAnswer = "";
      if (
        (typeof changedValue != "string" || !changedValue instanceof String) &&
        isNaN(changedValue)
      ) {
        if (changedValue?.text?.[languagecode]) {
          newAnswer = changedValue?.text?.[languagecode];
          oldAnswer = node.answer?.text?.[languagecode];
        } else if (changedValue?.detail?.result?.formatted_address) {
          newAnswer = changedValue?.detail?.result?.formatted_address;
          oldAnswer = node.answer?.detail?.result?.formatted_address;
        } else if (changedValue?.mainanswer) {
          newAnswer = changedValue?.mainanswer;
          oldAnswer = node.answer?.mainanswer;
        } else if (node.answer?.streetNumber) {
          for (let key in node.answer) {
            oldAnswer += node.answer[key] + " ";
            newAnswer += changedValue[key] + " ";
          }
        } else if (Array.isArray(changedValue)) {
          if (Array.isArray(node?.answer))
            oldAnswer = node.answer
              .map((x) => x.text?.[languagecode])
              .join(",");
          newAnswer = changedValue.map((x) => x.text?.[languagecode]).join(",");
        } else if (
          typeof changedValue === "object" &&
          changedValue !== null &&
          !Array.isArray(changedValue)
        ) {
          let differnces = findDifferences(node.answer, changedValue);
          if (Array.isArray(differnces) && differnces.length > 0) {
            differnces.map((newentry) =>
              dispatch(AddtoClientLog({ newentry }))
            );
          }
        } else {
        }
      } else {
        newAnswer = changedValue;
        oldAnswer = node.answer;
      }
      oldAnswer ??= "";
      newAnswer ??= "";
      var newentry = {
        question: node.text?.[languagecode],
        old_answer: oldAnswer,
        new_answer: newAnswer,
      };
      if (oldAnswer != newAnswer) dispatch(AddtoClientLog({ newentry }));
    }

    dispatch(answerChanged({ node, changedValue, isBuilding }));
    dispatch(
      updateTrackingQAnsweredFinalValues({ formChangedId: node.formid })
    );
  };

  useEffect(() => {
    if (!node) {
      return;
    }

    // For address questions (ending in "110") with locationid, handle _no suffix logic
    if (
      node.id &&
      node.id.slice(-3) === "110" &&
      node.locationid
    ) {
      const sameAsMainValue = sessionStorage.getItem(`location_${node.locationid}_500100`);
      let isNo = false;

      try {
        // Parse the JSON value and check if it's "No"
        isNo = JSON.parse(sameAsMainValue) === "No";
      } catch (e) {
        // If parsing fails, try direct comparison
        isNo = sameAsMainValue === "No";
      }

      // If "Same as Main?" is "No", use the _no key
      if (isNo) {
        const noKey = node.id + "_no";
        const storedAddress = sessionStorage.getItem(noKey);

        if (storedAddress) {
          // Load existing custom address from _no key
          try {
            const parsedAddress = JSON.parse(storedAddress);

            // FIX: Only dispatch if current answer is different or empty
            // This prevents overwriting data that was already restored by prefillAddressParts
            const currentAnswer = node.answer;
            const isCurrentEmpty = !currentAnswer ||
              (typeof currentAnswer === 'object' && Object.values(currentAnswer).every(v => !v));

            if (isCurrentEmpty || JSON.stringify(currentAnswer) !== storedAddress) {
              dispatch(answerChanged({ node, changedValue: parsedAddress }));
            }
          } catch (e) {
            console.error("Failed to parse stored address:", e);
          }
        }
        // REMOVED: Don't initialize empty address - let prefillAddressParts handle it
        // This was causing the address to be cleared on every mount
      }
    }
  }, [node?.id, node?.answer, node?.locationid]); // FIX: Add dependencies to re-run when needed

  useEffect(() => {
    if (isNodeOpen) {
      if (node?.formtype == "operation") return;
      if (queRef.current && !isInViewport(queRef.current)) {
        queRef.current.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center",
        });
      }
    }
  }, [isNodeOpen]);

  useEffect(() => {
    if (!qflashid) return;
    if (qflashid != node.id) return;
    let flashCount = 0;
    const maxFlashes = 4;
    const interval = setInterval(() => {
      if (queRef.current) {
        queRef.current.style.backgroundColor =
          queRef.current.style.backgroundColor ===
          theme.COLORS.question_background
            ? null
            : theme.COLORS.question_background;
      }
      flashCount++;
      if (flashCount >= maxFlashes) {
        clearInterval(interval);
        dispatch(handleflashQid());
        if (queRef.current) {
          queRef.current.style.backgroundColor = null;
        }
      }
    }, 500);

    return () => clearInterval(interval);
  }, [qflashid, dispatch]);

  const invalidQuestionText = (text) => {
    if (text === null || text === "" || _.isEmpty(text)) return true;
    return false;
  };
  const displayQuestion = () => {
    if(node.logic?.hidefromform){
      return "none";
    }
    if (
      isExpressApplication &&
      node.importance <= importanceFactor &&
      formid != "h" && (!node.answer || ( (node.answer?.mainanswer === '' && !node.answer?.tablearray?.length ) || false ) ) &&
      !["e_320"].includes(groupid)
    ) {
      return "none";
    }
    return "flex";
  };
  useEffect(() => {
    const lowerImportance = () => {
      if (
        node?.interestedinsurercodes?.length &&
        node?.importance > 3 &&
        !node?.forceimportance
      ) {
        let isFound = node.interestedinsurercodes.some((r) =>
          gotProspectDetails.interestedinsurercodes.includes(r)
        );
        if (!isFound) {
          dispatch(
            manipulateQuestion({ node, key: "importance", newValue: 3 })
          );
        }
      }
    };
    lowerImportance();
  }, [gotProspectDetails, node]);

  return (
    <div
      ref={queRef}
      id={`QuestionID_${node.id}`}
      style={{
        minHeight: invalidQuestionText(text)
          ? 0
          : theme.SCALES.simpleQuestionsHeight,
        display: displayQuestion(),
        justifyContent: "center",
        alignItems: "center",
        marginTop: "0vh",
        marginBottom: type === MESSAGE ? 0 : "0.5vh",
        fontFamily: "GibsonRegular",
        borderRadius: theme.SCALES.groupTabBorderRadius,
        fontSize: "1.6vmin",
        transition: "background-color 0.3s ease",
      }}
      onMouseOver={() => {
        dispatch(changeHelpOrTipText(hint));
      }}
      onMouseOut={() => {
        // dispatch(changeHelpOrTipText(""));
      }}
      onFocus={() => {
        dispatch(changeHelpOrTipText(hint));
      }}
      onBlur={() => {
        dispatch(changeHelpOrTipText(""));
      }}
    >
      <QuestionComponent
        text={text}
        node={node}
        handleAnswerChange={handleAnswerChange}
        isNodeOpen={isNodeOpen}
        qfusermode={qfusermode}
        hint={hint}
        formid={formid}
      ></QuestionComponent>
    </div>
  );
};

export default EachQuestion;